import NotificationsContainer from '@common/elements/notifications/NotificationsContainer';

const NotificationsPlugin = {
  install(Vue, options = {}) {
    if (this.installed) {
      return;
    }
    this.installed = true;
    this.rootInstance = null;
    this.queue = [];

    Vue.mixin({
      beforeMount() {
        if (NotificationsPlugin.rootInstance === null) {
          NotificationsPlugin.rootInstance = this.$root;
          flushQueue();
        }
      },
    });

    const getContainer = () => {
      if (!NotificationsPlugin.rootInstance) {
        return null;
      }
      if (NotificationsPlugin.rootInstance._notificationsContainer) {
        return NotificationsPlugin.rootInstance._notificationsContainer;
      }
      const container = document.createElement('div');
      document.body.appendChild(container);

      new Vue({
        parent: NotificationsPlugin.rootInstance,
        render: h => h(NotificationsContainer),
      }).$mount(container);

      return NotificationsPlugin.rootInstance._notificationsContainer;
    };

    const flushQueue = () => {
      if (!NotificationsPlugin.queue.length) {
        return;
      }
      const container = getContainer();
      if (!container) {
        return;
      }
      NotificationsPlugin.queue.forEach(item => {
        if (item.type === 'show') {
          container.show(item.component, item.props);
          return;
        }
        if (item.type === 'hide') {
          container.hide();
        }
      });
      NotificationsPlugin.queue = [];
    };

    Vue.prototype.$notification = {
      show(component, props) {
        const container = getContainer();
        if (container) {
          container.show(component, props);
          return;
        }
        NotificationsPlugin.queue.push({type: 'show', component, props});
      },
      hide() {
        const container = getContainer();
        if (container) {
          container.hide();
          return;
        }
        NotificationsPlugin.queue.push({type: 'hide'});
      },
    };
  },
};

export default NotificationsPlugin;
